import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaUpload, FaPlay, FaDownload, FaTrash } from "react-icons/fa";
import { NODE_HOST_URL, NODE_HOST_URL_v1 } from "../api/Api";
import ReactTooltip from "react-tooltip";
import DashboardHeader from "../../Header/DashboardHeader";
import DashboardFooter from "../../Footer/DashboardFooter";
import DashboardLeftMenu from "../../Dashboard/DashboardLeftMenu";
import AdvanceDataTable from "../../UI/Table/AdvanceDataTable";
import styles from "./TTSUploadClip.module.css";
import { handleUserLog } from "../../Utils/Utils";

const UploadClip = () => {
  const [selectedGroup, setSelectedGroup] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedOption, setSelectedOption] = useState("audio");
  const [ttsMessage, setTtsMessage] = useState("");
  const [language, setLanguage] = useState("");
  const [gender, setGender] = useState("female");
  const [fileName, setFileName] = useState("");
  const [loading, setLoading] = useState(false);
  const [groups, setGroups] = useState([]);
  const [clips, setClips] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showPlayModal, setShowPlayModal] = useState(false);
  const [audioUrl, setAudioUrl] = useState("");
  const [clipToDelete, setClipToDelete] = useState(null);

  const loginData = JSON.parse(localStorage.getItem("login"));
  const user_id = loginData?.user?.userId;
  const token = loginData?.token;
  const username = loginData?.user?.name;


  const fetchGroups = async () => {
    try {
      const res = await axios.post(`${NODE_HOST_URL_v1}/clipGroup`, {
        user_id,
        token,
        method: "fetch_ttsclip_group",
      });
      if (res.data?.success && Array.isArray(res.data.data)) {
        setGroups(res.data.data);
      }
    } catch (err) {
      console.error("Failed to fetch groups", err);
    }
  };

  const fetchClipsByGroupId = async (groupId) => {
    try {
      setLoading(true);
      const res = await axios.post(`${NODE_HOST_URL_v1}/clipGroup`, {
        user_id,
        token,
        method: "fetch_tts_clip",
        clip_groupid: groupId,
      });
      if (res.data?.success && Array.isArray(res.data.data)) {
        setClips(res.data.data);
      } else {
        setClips([]);
      }
    } catch (err) {
      console.error("Failed to fetch clips", err);
      setClips([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchAllGroupsAndClips = async () => {
      try {
        const res = await axios.post(`${NODE_HOST_URL_v1}/clipGroup`, {
          user_id,
          token,
          method: "fetch_ttsclip_group",
        });

        if (res.data?.success && Array.isArray(res.data.data)) {
          const groupList = res.data.data;
          setGroups(groupList);

          // Fetch clips from all groups
          const allClips = [];
          for (const group of groupList) {
            const clipRes = await axios.post(`${NODE_HOST_URL_v1}/clipGroup`, {
              user_id,
              token,
              method: "fetch_tts_clip",
              clip_groupid: group.id,
            });

            if (clipRes.data?.success && Array.isArray(clipRes.data.data)) {
              allClips.push(...clipRes.data.data);
            }
          }

          setClips(allClips);
        }
      } catch (err) {
        console.error("Failed to fetch groups or clips", err);
      } finally {
        setLoading(false);
      }
    };

    fetchAllGroupsAndClips();
  }, []);


  const handleUpload = async () => {
    if (!selectedGroup) {
      setErrorMessage("Please select a group.");
      return;
    }

    const formData = new FormData();
    formData.append("user_id", user_id);
    formData.append("username", username);
    formData.append("token", token);
    formData.append("groupId", selectedGroup);

    setLoading(true);
    setSuccessMessage("");
    setErrorMessage("");

    try {
      if (selectedOption === "audio") {
        if (!selectedFile) {
          setErrorMessage("Please select a file to upload.");
          setLoading(false);
          return;
        }
        formData.append("method", "upload_audio_tts");
        formData.append("file", selectedFile);
      } else {
        if (!fileName || !ttsMessage || !language || !gender) {
          setErrorMessage("Please fill in all required TTS fields.");
          setLoading(false);
          return;
        }

        if (fileName.length > 50) {
          setErrorMessage("Clip Name should not exceed 50 characters.");
          setLoading(false);
          return;
        }


        formData.append("method", "create_tts");
        formData.append("fileName", fileName);
        formData.append("tts_message", ttsMessage);
        formData.append("language", language);
        formData.append("gender", gender);
      }

      const res = await axios.post(`${NODE_HOST_URL_v1}/clipGroup`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (res.data?.success) {
        setSuccessMessage("Upload successful!");
        setSelectedFile(null);
        setFileName("");
        setTtsMessage("");
        setLanguage("");
        setGender("female");
        handleUserLog("", "upload_clip_button", "tts_upload_clip", "Upload successful!", "tts_upload_clip", "", { group_id: selectedGroup, type: selectedOption });
        fetchClipsByGroupId(selectedGroup);
      } else {
        setErrorMessage(res.data?.message || "Upload failed.");
        handleUserLog("", "upload_clip_button", "tts_upload_clip", res.data?.message || "Upload failed.", "tts_upload_clip", "", { group_id: selectedGroup, type: selectedOption });
      }
    } catch (err) {
      console.error("Upload error", err);
      setErrorMessage(err.response?.data?.message);
      handleUserLog("", "upload_clip_button", "tts_upload_clip", err.response?.data?.message || "Upload error", "tts_upload_clip", "", { group_id: selectedGroup, type: selectedOption });
    } finally {
      setLoading(false);
    }

  };
  const downloadAudio = async (filePath) => {
    console.log("clicked");
    handleUserLog("", "download_clip_button", "tts_upload_clip", "User click on download clip button", "tts_upload_clip", "", { file_path: filePath });

    const fileUrl = `https://db2.authkey.io/${filePath}`;
    const fileName = "my-audio.mp3";

    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = fileName; // this forces the download with a specific file name
      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(blobUrl); // cleanup
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  const handleDeleteClip = async (clipId) => {
    try {
      setLoading(true);

      const res = await axios.post(`${NODE_HOST_URL_v1}/clipGroup`, {
        user_id,
        token,
        method: "deleteClip",
        id: clipId,
      });

      if (res.data?.success) {
        setSuccessMessage("Clip deleted successfully.");
        handleUserLog("", "delete_clip_button", "tts_upload_clip", "Clip deleted successfully.", "tts_upload_clip", "", { clip_id: clipId });

        // Refresh list
        if (selectedGroup) {
          fetchClipsByGroupId(selectedGroup);
        } else {
          // fetch all clips again
          const allClips = [];
          for (const group of groups) {
            const clipRes = await axios.post(`${NODE_HOST_URL_v1}/clipGroup`, {
              user_id,
              token,
              method: "fetch_tts_clip",
              clip_groupid: group.id,
            });
            if (clipRes.data?.success && Array.isArray(clipRes.data.data)) {
              allClips.push(...clipRes.data.data);
            }
          }
          setClips(allClips);
        }
      } else {
        setErrorMessage(res.data?.message || "Failed to delete clip.");
        handleUserLog("", "delete_clip_button", "tts_upload_clip", res.data?.message || "Failed to delete clip.", "tts_upload_clip", "", { clip_id: clipId });
      }
    } catch (err) {
      console.error("Delete error:", err);
      setErrorMessage("Error deleting clip.");
      handleUserLog("", "delete_clip_button", "tts_upload_clip", "Error deleting clip.", "tts_upload_clip", "", { clip_id: clipId });
    } finally {
      setShowDeleteModal(false);
      setLoading(false);
    }
  };


  const CLIP_TABLE_COLUMNS = [
    {
      name: "Clip ID",
      //  selector: row => row.id, 
      cell: (row) => (
        <>
          <span
            data-tip
            data-for={`tooltip-clipid-${row.id}`}
            style={{ cursor: "pointer" }}
          >
            {row.id}
          </span>
          <ReactTooltip id={`tooltip-clipid-${row.id}`} place="top" effect="solid">
            {row.tts?.trim() ? row.tts : "This is an audio file"}
          </ReactTooltip>
        </>
      ),
      sortable: true
    },
    {
      name: "Clip Name",
      // selector: row => row.clip_name
      cell: (row) => (
        <>
          <span
            data-tip
            data-for={`tooltip-clipname-${row.id}`}
            style={{ cursor: "pointer" }}
          >
            {row.clip_name}
          </span>
          <ReactTooltip id={`tooltip-clipname-${row.id}`} place="top" effect="solid">
            {row.tts?.trim() ? row.tts : "This is an audio file"}
          </ReactTooltip>
        </>
      ),
    },
    {
      name: "File Name",
      width: "250px",

      // selector: row => row.filename 
      cell: (row) => (
        <>
          <span
            data-tip
            data-for={`tooltip-filename-${row.id}`}
            style={{ cursor: "pointer" }}
          >
            {row.filename}
          </span>
          <ReactTooltip id={`tooltip-filename-${row.id}`} place="top" effect="solid">
            {row.tts?.trim() ? row.tts : "This is an audio file"}
          </ReactTooltip>
        </>
      ),
    },
    {
      name: "Duration",
      selector: (row) =>
        typeof row.duration === "number" ? `${row.duration}s` : "--",
      sortable: true,
    },
    {
      name: "Status",
      width: "150px",
      cell: (row) => {
        let bgColor = "";
        let textColor = "";

        if (row.status === 1) {
          bgColor = "#e9fce9";   // Light green background
          textColor = "#046c2fff"; // Dark green text
        } else if (row.status === 0) {
          bgColor = "#fff3cd";   // Light yellow background
          textColor = "#856404"; // Dark yellow text
        } else if (row.status === 2) {
          bgColor = "#ffe6e6";   // Light red background
          textColor = "#b30000"; // Dark red text
        }

        return (
          <span
            className={styles.badge}
            style={{
              backgroundColor: bgColor,
              color: textColor,
              padding: "4px 12px",
              borderRadius: "9999px",
              fontWeight: 600,
              fontSize: "14px",
            }}
          >
            {row.status === 1
              ? "Approved"
              : row.status === 0
                ? "Pending"
                : "Rejected"}
          </span>
        );
      },
    },

    {
      name: "Created Date",
      selector: row => new Date(row.created_date).toLocaleString(),
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className={styles.actions}>
          {/* Play */}
          <button
            className={styles.actionBtn}
            title="Play"
            onClick={() => {
              handleUserLog("", "play_clip_button", "tts_upload_clip", "User click on play clip button", "tts_upload_clip", "", { clip_id: row.id, file_path: row.file_path });
              setAudioUrl(`https://db2.authkey.io/${row.file_path}`);
              setShowPlayModal(true);
            }}
          >
            <FaPlay />
          </button>

          {/* Download */}
          <button
            className={styles.actionBtn}
            title="Download"
            onClick={() => downloadAudio(row.file_path)}
          >
            <FaDownload />
          </button>

          {/* Delete – ONLY Pending or Rejected */}
          {(row.status === 0 || row.status === 2) && (
            <button
              className={`${styles.actionBtn} ${styles.deleteBtn}`}
              title="Delete"
              onClick={() => {
                handleUserLog("", "delete_clip_button", "tts_upload_clip", "User click on delete clip button", "tts_upload_clip", "", { clip_id: row.id, clip_name: row.clip_name });
                // setClipToDelete(row.id);
                setClipToDelete(row);

                setShowDeleteModal(true);
              }}
            >
              <FaTrash />
            </button>
          )}
        </div>
      ),
    },
  ];

  return (
    <div className={styles.wrapper}>
      <DashboardLeftMenu />
      <div className={styles.main}>
        <DashboardHeader />
        <h4 className={styles.heading}>Upload Clip in Group</h4>

        {successMessage && (
          <div className="alert alert-success d-flex justify-content-between align-items-center">
            <span>{successMessage}</span>
            <button onClick={() => setSuccessMessage("")} style={{ background: "none", border: "none", fontSize: "20px" }}>
              &times;
            </button>
          </div>
        )}
        {errorMessage && (
          <div className="alert alert-danger d-flex justify-content-between align-items-center">
            <span>{errorMessage}</span>
            <button onClick={() => setErrorMessage("")} style={{ background: "none", border: "none", fontSize: "20px" }}>
              &times;
            </button>
          </div>
        )}

        <div className={styles.card}>
          <div className={styles.formGroup}>
            <label className={styles.label}>Type</label>
            <div className={styles.radioButtons}>
              <label>
                <input
                  type="radio"
                  name="uploadType"
                  value="audio"
                  checked={selectedOption === "audio"}
                  onChange={() => setSelectedOption("audio")}
                /> Audio
              </label>
              <label>
                <input
                  type="radio"
                  name="uploadType"
                  value="tts"
                  checked={selectedOption === "tts"}
                  onChange={() => setSelectedOption("tts")}
                /> TTS
              </label>
            </div>
          </div>

          <div className={styles.formGroup}>
            <label className={styles.label}>Select Group</label>
            <select
              className={styles.select}
              value={selectedGroup}
              onChange={(e) => {
                const groupId = e.target.value;
                setSelectedGroup(groupId);

                if (groupId === "") {
                  // Show all clips if no group selected
                  const fetchAll = async () => {
                    const allClips = [];
                    for (const group of groups) {
                      const res = await axios.post(`${NODE_HOST_URL_v1}/clipGroup`, {
                        user_id,
                        token,
                        method: "fetch_tts_clip",
                        clip_groupid: group.id,
                      });

                      if (res.data?.success && Array.isArray(res.data.data)) {
                        allClips.push(...res.data.data);
                      }
                    }
                    setClips(allClips);
                  };

                  fetchAll();
                } else {
                  fetchClipsByGroupId(groupId);
                }
              }}

            >
              <option value="">All Groups</option>
              {groups.map((group) => (
                <option key={group.id} value={group.id}>
                  {group.name}
                </option>
              ))}
            </select>
          </div>

          {selectedOption === "audio" && (
            <>
              <div className={styles.formGroup}>
                <label className={styles.label}>Choose File</label>
                <input
                  type="file"
                  className={styles.inputFile}
                  accept=".mp3"
                  onChange={(e) => setSelectedFile(e.target.files[0])}
                />
              </div>
              <button className={styles.uploadBtn} onClick={handleUpload} disabled={loading}>
                {loading ? "Uploading..." : <><FaUpload className={styles.icon} /> Upload</>}
              </button>
            </>
          )}

          {selectedOption === "tts" && (
            <>
              <div className={styles.formGroup}>
                <label className={styles.label}>File Name *</label>
                <input
                  type="text"
                  className={styles.input}
                  value={fileName}
                  // onChange={(e) => setFileName(e.target.value)}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value.length <= 50) {
                      setFileName(value);
                    }
                  }}
                  placeholder="Enter file name"
                  maxLength={50}
                />
              </div>
              <small style={{ float: 'right', color: '#888' }}>
                {fileName.length}/50
              </small>


              <div className={styles.formGroup}>
                <label className={styles.label}>TTS Message *</label>
                <textarea
                  className={styles.input}
                  value={ttsMessage}
                  onChange={(e) => setTtsMessage(e.target.value)}
                  // onChange={(e) => {
                  //   const value = e.target.value;
                  //   if (value.length <= 50) {
                  //     setTtsMessage(value);
                  //   }
                  // }}
                  placeholder="Enter the message for TTS"
                // maxLength={300}
                />
              </div>
              {/* <small style={{ float: 'right', color: '#888' }}>
                {ttsMessage.length}/300
              </small> */}
              <div className="row">
                <div className="col-6">
                  <label className={styles.label}>Language *</label>
                  <select
                    className={styles.select}
                    value={language}
                    onChange={(e) => setLanguage(e.target.value)}
                  >
                    <option value="">--SELECT LANGUAGE--</option>
                    <option value="en-IN">English (India)</option>
                    <option value="hi-IN">Hindi</option>
                    <option value="gu-IN">Gujarati</option>
                    <option value="bn-IN">Bengali</option>
                    <option value="kn-IN">Kannada</option>
                    <option value="ml-IN">Malayalam</option>
                    <option value="pa-IN">Punjabi</option>
                    <option value="ta-IN">Tamil</option>
                    <option value="te-IN">Telugu</option>
                    <option value="es-ES">Spanish</option>
                  </select>
                </div>
                <div className="col-6">
                  <label className={styles.label}>Gender *</label>
                  <select
                    className={styles.select}
                    value={gender}
                    onChange={(e) => setGender(e.target.value)}
                  >
                    <option value="female">Female</option>
                    {/* <option value="male">Male</option>  */}
                  </select>
                </div>
              </div>
              <button className={`${styles.uploadBtn} mt-3`} onClick={handleUpload} disabled={loading}>
                {loading ? "Uploading..." : <><FaUpload className={styles.icon} /> Upload</>}
              </button>
            </>
          )}
        </div>

        <h5 className={styles.heading}>Clip List</h5>
        <div className="mt-3">
          <AdvanceDataTable
            tableCell={CLIP_TABLE_COLUMNS}
            tableData={clips}
            isLoading={loading}
            className="table"
          />
        </div>

        {/* Bootstrap-style Modal */}
     {showDeleteModal && (
  <div className={styles.modalOverlay}>
    <div className={styles.deleteModal}>
      <h3 className={styles.modalTitle}>Delete clip</h3>

      <p className={styles.modalText}>
        Are you sure you want to delete{" "}
        <strong>{clipToDelete.clip_name}</strong>?<br />
        This action cannot be undone.
      </p>

      <div className={styles.modalActions}>
        <button
          className={styles.cancelBtn}
          onClick={() => setShowDeleteModal(false)}
        >
          Cancel
        </button>

        <button
          className={styles.confirmDeleteBtn}
          onClick={() => handleDeleteClip(clipToDelete.id)}
        >
          Delete
        </button>
      </div>
    </div>
  </div>
)}


        {showPlayModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              background: "rgba(0,0,0,0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1000,
            }}
          >
            <div
              style={{
                background: "#fff",
                padding: "20px",
                borderRadius: "8px",
                width: "400px",
                boxShadow: "0 0 10px rgba(0,0,0,0.3)",
              }}
            >
              <h5>Play Audio</h5>
              <p><strong>File:</strong> {fileName}</p>
              <audio
                controls
                autoPlay
                src={audioUrl}
                style={{ width: "100%" }}
              />
              <div className="text-end mt-3">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowPlayModal(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}



        <DashboardFooter />
      </div>
    </div >
  );
};

export default UploadClip;
